import React, { useState, useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, ArrowRight, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

function ContactWidget() {
    const [hoverButton, setHoverButton] = useState(null);

    return (
        <section className="py-16 bg-gradient-to-b from-white to-gray-50 dark:from-gray-900 dark:to-gray-950">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    className="bg-gradient-to-br from-gray-700 to-amber-700 dark:from-gray-800 dark:to-amber-950 rounded-2xl overflow-hidden shadow-xl dark:shadow-amber-900/20"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3, duration: 0.8 }}
                >
                    {/* Light theme decorative pattern */}
                    <div className="absolute inset-0 overflow-hidden opacity-5 light-only">
                        <div className="absolute w-full h-full">
                            {[...Array(20)].map((_, index) => (
                                <div
                                    key={index}
                                    className="absolute bg-white rounded-full"
                                    style={{
                                        width: Math.random() * 8 + 2 + 'px',
                                        height: Math.random() * 8 + 2 + 'px',
                                        left: Math.random() * 100 + '%',
                                        top: Math.random() * 100 + '%',
                                        opacity: Math.random() * 0.5 + 0.3,
                                    }}
                                />
                            ))}
                        </div>
                    </div>

                    {/* Dark theme decorative pattern */}
                    <div className="absolute inset-0 overflow-hidden opacity-10 dark-only">
                        <div className="absolute w-full h-full">
                            <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500 rounded-full filter blur-3xl opacity-20 -mr-32 -mt-32"></div>
                            <div className="absolute bottom-0 left-0 w-64 h-64 bg-amber-600 rounded-full filter blur-3xl opacity-20 -ml-32 -mb-32"></div>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 relative">
                        {/* Map side */}
                        <div className="relative h-64 lg:h-auto">
                            <div className="absolute inset-0">
                                <img
                                    src="https://ik.imagekit.io/jncw2kb8u/hotel-in-una1.jpg?updatedAt=1745481996268"
                                    alt="Our Headquarters"
                                    className="w-full h-full object-cover"
                                />
                                <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent dark:from-black/70 dark:to-transparent"></div>
                            </div>

                            <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent dark:from-black/70 dark:to-transparent"></div>

                            <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                                <div className="inline-flex items-center gap-2 mb-3 bg-yellow-900/70 dark:bg-amber-900/50 py-1 px-3 rounded-full">
                                    <MapPin className="h-4 w-4 text-yellow-200 dark:text-amber-300" />
                                    <span className="text-xs font-medium text-yellow-100 dark:text-amber-200">Our Location</span>
                                </div>
                                <h3 className="text-xl font-light mb-2">Our <span className="font-medium">Headquarters</span></h3>
                                <p className="text-gray-300 dark:text-amber-100/70 text-sm">Dev Bhoomi Group Companies, 8 mile stone, Behdala Una, Himachal Pradesh 174306</p>
                            </div>
                        </div>

                        {/* Content side */}
                        <div className="p-8 md:p-12 text-white relative">
                            {/* Small decorative element for light theme */}
                            <div className="absolute top-0 right-0 w-20 h-20 bg-yellow-600/20 rounded-bl-3xl light-only"></div>

                            {/* Small decorative element for dark theme */}
                            <div className="absolute top-0 right-0 w-24 h-24 bg-amber-600/10 rounded-bl-full dark-only border-l border-b border-amber-700/20"></div>

                            <h3 className="text-3xl font-light mb-2 flex flex-col">
                                Connect <span className="font-medium">With Us</span>
                            </h3>

                            <div className="w-16 h-1 bg-yellow-500 dark:bg-amber-400 mb-6 rounded-full"></div>

                            <p className="text-yellow-200 dark:text-amber-200 mb-8">
                                Our representatives are available to assist you with any inquiries about our locations or services. Reach out to schedule a visit or request more information.
                            </p>

                            <div className="space-y-4 mb-8">
                                <div className="flex items-center">
                                    <div className="h-10 w-10 rounded-full bg-yellow-800/50 dark:bg-amber-700/30 flex items-center justify-center text-yellow-300 dark:text-amber-300">
                                        <Phone className="h-5 w-5" />
                                    </div>
                                    <div className="ml-4">
                                        <div className="text-sm font-light text-yellow-200 dark:text-amber-200">Telephone</div>
<a
  href="tel:+916230562314"
  className="text-white dark:text-white font-medium hover:text-amber-400 transition-colors"
>
  +91 6230562314
</a>
                                    </div>
                                </div>

                                <div className="flex items-center">
                                    <div className="h-10 w-10 rounded-full bg-yellow-800/50 dark:bg-amber-700/30 flex items-center justify-center text-yellow-300 dark:text-amber-300">
                                        <Mail className="h-5 w-5" />
                                    </div>
                                    <div className="ml-4">
                                        <div className="text-sm font-light text-yellow-200 dark:text-amber-200">Email</div>
                                        <div className="text-white dark:text-white font-medium">info@devbhoomigroup.in</div>
                                    </div>
                                </div>
                            </div>

                            <div className="flex flex-wrap gap-4">
                                {/* both theme primary button */}
                                <Link to={"/contact"} >
                                    <motion.button
                                        className="px-6 py-3 bg-white text-gray-900 dark:bg-gradient-to-r dark:from-amber-500 dark:to-amber-600 dark:text-white dark:hover:shadow-amber-500/30 font-medium text-sm rounded-md shadow-md hover:bg-gray-100 transition-all light-only"
                                        whileHover={{ scale: 1.03 }}
                                        whileTap={{ scale: 0.97 }}
                                        onMouseEnter={() => setHoverButton('contact')}
                                        onMouseLeave={() => setHoverButton(null)}
                                    >
                                        <span className="flex items-center">
                                            Contact Us
                                            <motion.span
                                                animate={{ x: hoverButton === 'contact' ? 5 : 0, opacity: hoverButton === 'contact' ? 1 : 0.7 }}
                                                transition={{ duration: 0.3 }}
                                                className="ml-2"
                                            >
                                                <ChevronRight className="h-4 w-4" />
                                            </motion.span>
                                        </span>
                                    </motion.button>
                                </Link>

                                {/* both theme secondary button */}
                                <Link to={"/about"} >
                                    <motion.button
                                        className="px-6 py-3 bg-transparent border border-white/30 text-white dark:border-amber-500/30 dark:text-amber-100 font-medium text-sm rounded-md hover:bg-white/10 dark:hover:bg-amber-500/10 transition-all light-only"
                                        whileHover={{ scale: 1.03 }}
                                        whileTap={{ scale: 0.97 }}
                                        onMouseEnter={() => setHoverButton('learn')}
                                        onMouseLeave={() => setHoverButton(null)}
                                    >
                                        <span className="flex items-center">
                                            Learn More
                                            <motion.span
                                                animate={{ x: hoverButton === 'learn' ? 5 : 0, opacity: hoverButton === 'learn' ? 1 : 0.7 }}
                                                transition={{ duration: 0.3 }}
                                                className="ml-2"
                                            >
                                                <ChevronRight className="h-4 w-4" />
                                            </motion.span>
                                        </span>
                                    </motion.button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}

export default ContactWidget;